// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: oLOXXtuNDrR0
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import SurchargeBank from "../../SurchargeBank"; // plasmic-import: h-kL213reSam/component
import SurchargeCard from "../../SurchargeCard"; // plasmic-import: aKQhSPWnxNXs/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicEscrowPaymentsPageSurcharge.module.css"; // plasmic-import: oLOXXtuNDrR0/css
import Line2Icon from "./icons/PlasmicIcon__Line2"; // plasmic-import: pAewef34g4ck/icon
import Line1Icon from "./icons/PlasmicIcon__Line1"; // plasmic-import: MRg3okKdNvAo/icon
import Layer11Icon from "./icons/PlasmicIcon__Layer11"; // plasmic-import: z3YAObc8gkKH/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: jmxAADuTvJ3W/icon

createPlasmicElementProxy;

export const PlasmicEscrowPaymentsPageSurcharge__VariantProps = new Array();

export const PlasmicEscrowPaymentsPageSurcharge__ArgProps = new Array(
  "merchantName",
  "contractName",
  "amount",
  "milestoneName",
  "escrowDeposit",
  "milestoneOrContract"
);

const $$ = {};

function PlasmicEscrowPaymentsPageSurcharge__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"previewBody"}
            data-plasmic-override={overrides.previewBody}
            className={classNames(projectcss.all, sty.previewBody)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__nZztp)}>
              <div
                data-plasmic-name={"companyName"}
                data-plasmic-override={overrides.companyName}
                className={classNames(projectcss.all, sty.companyName)}
              >
                {renderPlasmicSlot({
                  defaultContents: "",
                  value: args.merchantName,
                  className: classNames(sty.slotTargetMerchantName)
                })}
              </div>
              <div
                data-plasmic-name={"rectangle29"}
                data-plasmic-override={overrides.rectangle29}
                className={classNames(projectcss.all, sty.rectangle29)}
              >
                <div
                  data-plasmic-name={"figmaPaste"}
                  data-plasmic-override={overrides.figmaPaste}
                  className={classNames(projectcss.all, sty.figmaPaste)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__m3Ell)}
                  >
                    {renderPlasmicSlot({
                      defaultContents: (
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__cCqSk
                          )}
                        >
                          {"Requested Milestone Deposit: $900.00"}
                        </div>
                      ),

                      value: args.escrowDeposit,
                      className: classNames(sty.slotTargetEscrowDeposit)
                    })}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__rV2Iq)}
                  >
                    {renderPlasmicSlot({
                      defaultContents: "Milestone 1: Initial Setup",
                      value: args.milestoneOrContract,
                      className: classNames(sty.slotTargetMilestoneOrContract)
                    })}
                  </div>
                  <Line2Icon
                    className={classNames(projectcss.all, sty.svg__eZs)}
                    role={"img"}
                  />

                  <div
                    data-plasmic-name={"viewDetails"}
                    data-plasmic-override={overrides.viewDetails}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.viewDetails
                    )}
                  >
                    {"View Full Contract Details  >"}
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"rectangle28"}
                data-plasmic-override={overrides.rectangle28}
                className={classNames(projectcss.all, sty.rectangle28)}
              >
                <div
                  data-plasmic-name={"figmaPaste2"}
                  data-plasmic-override={overrides.figmaPaste2}
                  className={classNames(projectcss.all, sty.figmaPaste2)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___88Gi1
                    )}
                  >
                    {"Choose your payment method"}
                  </div>
                  <Line1Icon
                    className={classNames(projectcss.all, sty.svg__mtv51)}
                    role={"img"}
                  />

                  <div
                    className={classNames(projectcss.all, sty.freeBox___4WlEt)}
                  >
                    <SurchargeBank
                      data-plasmic-name={"handleBankTransfer"}
                      data-plasmic-override={overrides.handleBankTransfer}
                      className={classNames(
                        "__wab_instance",
                        sty.handleBankTransfer
                      )}
                    />

                    <SurchargeCard
                      data-plasmic-name={"handleCardPayment"}
                      data-plasmic-override={overrides.handleCardPayment}
                      className={classNames(
                        "__wab_instance",
                        sty.handleCardPayment
                      )}
                    />
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"figmaPaste3"}
                data-plasmic-override={overrides.figmaPaste3}
                className={classNames(projectcss.all, sty.figmaPaste3)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__fbOtZ
                  )}
                >
                  {"Powered by astrius"}
                </div>
              </div>
            </div>
            <div
              data-plasmic-name={"sideBarInstance"}
              data-plasmic-override={overrides.sideBarInstance}
              className={classNames(projectcss.all, sty.sideBarInstance)}
            >
              <div className={classNames(projectcss.all, sty.freeBox___0Fz6R)}>
                {renderPlasmicSlot({
                  defaultContents: "Social Media Marketing",
                  value: args.contractName,
                  className: classNames(sty.slotTargetContractName)
                })}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__a3Xg2)}>
                {renderPlasmicSlot({
                  defaultContents: "$300.00",
                  value: args.amount,
                  className: classNames(sty.slotTargetAmount)
                })}
              </div>
              <div
                data-plasmic-name={"closeButton"}
                data-plasmic-override={overrides.closeButton}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.closeButton
                )}
              >
                {"X"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__nWnX
                )}
              >
                {"Qty 1"}
              </div>
              <div
                data-plasmic-name={"milestoneNameStack"}
                data-plasmic-override={overrides.milestoneNameStack}
                className={classNames(projectcss.all, sty.milestoneNameStack)}
              >
                {renderPlasmicSlot({
                  defaultContents: "Milestone 2: Social Media ",
                  value: args.milestoneName,
                  className: classNames(sty.slotTargetMilestoneName)
                })}
              </div>
              <Line1Icon
                className={classNames(projectcss.all, sty.svg__hrCc)}
                role={"img"}
              />

              <div
                data-plasmic-name={"viewContract"}
                data-plasmic-override={overrides.viewContract}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.viewContract
                )}
              >
                {"View Contract"}
              </div>
              <Line1Icon
                data-plasmic-name={"lowerBar"}
                data-plasmic-override={overrides.lowerBar}
                className={classNames(projectcss.all, sty.lowerBar)}
                role={"img"}
              />

              <div
                data-plasmic-name={"downloadContract"}
                data-plasmic-override={overrides.downloadContract}
                className={classNames(projectcss.all, sty.downloadContract)}
              >
                <Layer11Icon
                  className={classNames(projectcss.all, sty.svg___6Y5EI)}
                  role={"img"}
                />

                <div className={classNames(projectcss.all, sty.freeBox__nqg9F)}>
                  <IconIcon
                    className={classNames(projectcss.all, sty.svg__zOola)}
                    role={"img"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "previewBody",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "rectangle28",
    "figmaPaste2",
    "handleBankTransfer",
    "handleCardPayment",
    "figmaPaste3",
    "sideBarInstance",
    "closeButton",
    "milestoneNameStack",
    "viewContract",
    "lowerBar",
    "downloadContract"
  ],

  previewBody: [
    "previewBody",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "rectangle28",
    "figmaPaste2",
    "handleBankTransfer",
    "handleCardPayment",
    "figmaPaste3",
    "sideBarInstance",
    "closeButton",
    "milestoneNameStack",
    "viewContract",
    "lowerBar",
    "downloadContract"
  ],

  companyName: ["companyName"],
  rectangle29: ["rectangle29", "figmaPaste", "viewDetails"],
  figmaPaste: ["figmaPaste", "viewDetails"],
  viewDetails: ["viewDetails"],
  rectangle28: [
    "rectangle28",
    "figmaPaste2",
    "handleBankTransfer",
    "handleCardPayment"
  ],

  figmaPaste2: ["figmaPaste2", "handleBankTransfer", "handleCardPayment"],
  handleBankTransfer: ["handleBankTransfer"],
  handleCardPayment: ["handleCardPayment"],
  figmaPaste3: ["figmaPaste3"],
  sideBarInstance: [
    "sideBarInstance",
    "closeButton",
    "milestoneNameStack",
    "viewContract",
    "lowerBar",
    "downloadContract"
  ],

  closeButton: ["closeButton"],
  milestoneNameStack: ["milestoneNameStack"],
  viewContract: ["viewContract"],
  lowerBar: ["lowerBar"],
  downloadContract: ["downloadContract"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicEscrowPaymentsPageSurcharge__ArgProps,
          internalVariantPropNames:
            PlasmicEscrowPaymentsPageSurcharge__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicEscrowPaymentsPageSurcharge__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicEscrowPaymentsPageSurcharge";
  } else {
    func.displayName = `PlasmicEscrowPaymentsPageSurcharge.${nodeName}`;
  }
  return func;
}

export const PlasmicEscrowPaymentsPageSurcharge = Object.assign(
  // Top-level PlasmicEscrowPaymentsPageSurcharge renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    previewBody: makeNodeComponent("previewBody"),
    companyName: makeNodeComponent("companyName"),
    rectangle29: makeNodeComponent("rectangle29"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    viewDetails: makeNodeComponent("viewDetails"),
    rectangle28: makeNodeComponent("rectangle28"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    handleBankTransfer: makeNodeComponent("handleBankTransfer"),
    handleCardPayment: makeNodeComponent("handleCardPayment"),
    figmaPaste3: makeNodeComponent("figmaPaste3"),
    sideBarInstance: makeNodeComponent("sideBarInstance"),
    closeButton: makeNodeComponent("closeButton"),
    milestoneNameStack: makeNodeComponent("milestoneNameStack"),
    viewContract: makeNodeComponent("viewContract"),
    lowerBar: makeNodeComponent("lowerBar"),
    downloadContract: makeNodeComponent("downloadContract"),
    // Metadata about props expected for PlasmicEscrowPaymentsPageSurcharge
    internalVariantProps: PlasmicEscrowPaymentsPageSurcharge__VariantProps,
    internalArgProps: PlasmicEscrowPaymentsPageSurcharge__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicEscrowPaymentsPageSurcharge;
/* prettier-ignore-end */
